module.exports = "/assets/e83d141b583c45a5923219590cea77e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/OB.png
// module id = 1674
// module chunks = 0